import * as Sentry from '@sentry/react'

export async function incrConversationsMetric ({ chatClient, env, region, market }) {
  try {
    await chatClient.request({
      method: 'POST',
      url: '/v1/metrics/conversations',
      region: region,
      data: { environment: env, market }
    })
  } catch (err) {
    Sentry.captureException(err)
  }
}
